import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import CardBody from '../../shared/components/CardBody';
import Paginator from '../../shared/components/Paginator';
import { I18nUtils } from '../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import Row from '../../shared/components/Row';
import DocumentsTable from '../../shared/components/DocumentsTable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as documentStateActions from '../actions/documentStatesActions';
import * as documentsActions from '../actions/documentsActions';
import * as attachmentActions from '../../attachment/attachmentActions';
import StateManager from '../../shared/utils/StateManager';
import { ButtonLabel } from '../../shared/components/ButtonLabel';
import { CurrentUser } from '../../shared/model/CurrentUser';

const OptionsMore = {
    NONE: '',
    ATTACH: 'ATTACH',
};

class DocumentsCard extends React.Component {

    constructor(props) {
        super(props);

        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);
        this.onCollapsed = this.onCollapsed.bind(this);

        this.state = {
            ...StateManager.getState(this.props.id),
            collapsed: this.props.initCollapsed ? true : false,
            moreOptionSelected: OptionsMore.NONE,
        };
    }

    componentWillMount() {
        this.props.documentStateActions.getDocumentStates();
        if ( !this.state.collapsed ) {
            this.getDocuments();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            search,
            filter,
            page,
            collapsed,
        } = this.state;
        const {
            id,
            refreshDocuments,
            handleSetRefreshDocuments,
        } = this.props;

        if ( ( prevProps.refreshDocuments !== refreshDocuments ) && refreshDocuments ) {
            if ( !collapsed ) {
                handleSetRefreshDocuments(false);
                this.getDocuments();
            }
        }

        if ( prevState.search !== search
            || prevState.filter !== filter
            || prevState.page !== page
            || prevState.collapsed !== collapsed ) {
            if ( !collapsed ) {
                this.getDocuments();
            }
        }
        StateManager.saveState(id, this.state);
    }

    getDocuments() {
        const {
            id,
            workId,
            companyId,
            workerId,
            machineId,
            currentUser,
            includeCriteria,
            documentSchemaType,
            asSubcontracted,
        } = this.props;

        let documentSchemaTypeId = null;
        if ( documentSchemaType ) {
            documentSchemaTypeId = this.props.documentSchemaType;
        }

        const queryIds = {};
        if ( workId ) queryIds.construction_id = workId;
        if ( companyId ) queryIds.company_id = companyId;
        if ( workerId ) queryIds.worker_id = workerId;
        if ( machineId ) queryIds.machine_id = machineId;
        if ( asSubcontracted ) queryIds.as_subcontracted = asSubcontracted;

        this.props.documentsActions.getDocuments(
            id,
            this.state.page,
            this.state.search,
            this.state.filter,
            documentSchemaTypeId,
            queryIds,
            null,
            currentUser.isContractorsManager() ? {} : includeCriteria,
        );
    }

    onRefresh() {
        this.getDocuments();
    }

    onSearch(search) {
        this.setState({ search, page: 1 });
    }

    onCollapsed(collapsed) {
        this.setState({ collapsed: collapsed });
        if ( this.props.collapsed ) {
            this.props.collapsed(collapsed);
        }
    }

    onPage(page) {
        this.setState({ page });
    }

    getFilterOptions() {
        const filterOptions = this.props.documentStates.map((workerState) => {
            return {
                id: workerState.id,
                title: workerState.name,
                active: workerState.id === this.state.filter,
                color: '#' + workerState.color,
                onClick: () => {
                    this.setState({ filter: workerState.id, page: 1 });
                },
            };
        });

        filterOptions.unshift({
            id: 0,
            title: I18nUtils.tr('TR_TODOS'),
            active: 0 === this.state.filter,
            onClick: () => {
                this.setState({ filter: 0, page: 1 });
            },
        });

        return filterOptions;
    }

    getMoreOptions() {
        const { currentUser } = this.props;
        const { moreOptionSelected } = this.state;

        if ( currentUser.isSuperAdmin() || currentUser.isOutsourcesViewer() ) return [];

        return [
            {
                id: 'attach',
                title: I18nUtils.tr('TR_SUBIDA_MULTIPLE_DE_FICHEROS'),
                active: moreOptionSelected === OptionsMore.ATTACH,
                onClick: () => this.setState({ moreOptionSelected: OptionsMore.ATTACH }),
            },
        ];
    }

    renderFilterName() {
        const states = _.keyBy(this.getFilterOptions(), 'id');
        if ( states && states[this.state.filter] ) {
            return states[this.state.filter].title;
        }
        return '';
    }

    render() {
        const {
            title,
            documents,
            documentsError,
            documentsLoading,
            documentsPagination,
            documentsChecked,
            hideOutsource,
            initCollapsed,
            displayContractorColumn,
            isContractorViewer,
        } = this.props;

        const {
            search,
            collapsed,
            moreOptionSelected,
        } = this.state;

        const displayChecks = moreOptionSelected === OptionsMore.ATTACH;

        return (
            <Row clearfix>
                <Card loading={documentsLoading}>
                    <CardHeader
                        title={title.toUpperCase()}
                        subtitle={this.renderFilterName()}
                        rightOptions={
                            <HeaderSearchRefreshFilterOptions
                                onRefresh={this.onRefresh}
                                onSearch={this.onSearch}
                                searchText={search}
                                filterOptions={this.getFilterOptions()}
                                collapsed={collapsed}
                                onCollapsed={initCollapsed !== null ? this.onCollapsed : undefined}
                                moreOptions={this.getMoreOptions()}
                            />
                        }
                    />
                    {
                        !collapsed && (
                            <CardBody className="table-responsive">
                                <DocumentsTable
                                    data={documents}
                                    error={documentsError}
                                    hideOutsource={hideOutsource}
                                    displayContractorColumn={displayContractorColumn}
                                    checkedItemIds={documentsChecked}
                                    isContractorViewer={isContractorViewer}
                                    checkedAll={displayChecks ? this.handleDetermineAllChecked() : undefined}
                                    onCheck={displayChecks ? this.handleCheck : undefined}
                                    onCheckAll={displayChecks ? this.handleCheckAll : undefined}
                                    onUncheckAll={displayChecks ? this.handleUncheckAll : undefined}
                                />
                                <Paginator
                                    onPage={this.onPage}
                                    data={documentsPagination}
                                />
                                {
                                    displayChecks && (
                                        <Row>
                                            <ButtonLabel
                                                label={I18nUtils.tr('TR_CANCELAR')}
                                                className={'col-md-3 col-md-offset-6'}
                                                onClick={this.handleAttachCancel}
                                            />
                                            <ButtonLabel
                                                label={I18nUtils.tr('TR_SUBIR')}
                                                className={'col-md-3'}
                                                disabled={documentsChecked.length === 0}
                                                onClick={this.handleAttachAccept}
                                            />
                                        </Row>
                                    )
                                }
                            </CardBody>
                        )
                    }
                </Card>
            </Row>
        );
    }

    handleCheck = (document) => {
        this.props.attachmentActions.addOrRemoveDocToAttach(document);
    };

    handleCheckAll = () => {
        const { documents, attachmentActions } = this.props;
        attachmentActions.addAlldocsToAttach(documents);
    };

    // Para ejecutar este método todos deben estar chequeados en la página
    handleUncheckAll = () => {
        const { documents, attachmentActions } = this.props;
        attachmentActions.removeAllDocsToAttach(documents);
    };

    handleDetermineAllChecked = () => {
        const { documents, documentsChecked } = this.props;
        if ( documents.length === 0 ) return false;
        const ids = documents.map(doc => String(doc.id));
        return ids.every(id => documentsChecked.includes(id));
    };

    handleAttachCancel = () => {
        this.setState({ moreOptionSelected: OptionsMore.NONE });
        this.props.attachmentActions.clearAttachment();
    };

    handleAttachAccept = () => {
        const { documentsChecked, attachmentActions } = this.props;
        const doAttach = documentsChecked.length > 0;
        const currentPathname = window.document.location.pathname;
        if ( doAttach ) attachmentActions.goToRouteAttachment(currentPathname);
    };

}

const mapStateToProps = (state, ownProps) => {
    const documentStateItem = state.documents[ownProps.id] || { documents: [] };

    let errorMessage = documentStateItem.documentsError;
    if ( !errorMessage && documentStateItem.documents.length === 0 && !documentStateItem.documentsLoading ) {
        errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }

    return {
        currentUser: CurrentUser.fromReduxState(state),
        documents: documentStateItem.documents,
        documentsPagination: documentStateItem.documentsPagination,
        documentsLoading: documentStateItem.documentsLoading,
        documentsError: errorMessage,
        documentStates: state.documentStates.documentStates,
        documentsChecked: Object.keys(state.attachment.documents),
        documentsRefresh: ownProps.refreshDocuments,
        handleSetRefreshDocuments: ownProps.handleSetRefreshDocuments,
    };
};

const mapDispatchToProps = dispatch => ( {
    documentStateActions: bindActionCreators(documentStateActions, dispatch),
    documentsActions: bindActionCreators(documentsActions, dispatch),
    attachmentActions: bindActionCreators(attachmentActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsCard);

DocumentsCard.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    documentSchemaType: PropTypes.number,
    hideOutsource: PropTypes.bool,
    displayContractorColumn: PropTypes.bool,
    workId: PropTypes.string,
    machineId: PropTypes.string,
    workerId: PropTypes.number,
    companyId: PropTypes.string,
    initCollapsed: PropTypes.bool,
    collapsed: PropTypes.func,
    isContractorViewer: PropTypes.bool,
    asSubcontracted: PropTypes.bool,
    refreshDocuments: PropTypes.bool,
    handleSetRefreshDocuments: PropTypes.func,
};

DocumentsCard.defaultProps = {
    documentSchemaType: null,
    hideOutsource: false,
    initCollapsed: null,
    isContractorViewer: false,
    collapsed: (collapsed) => {},
};



// WEBPACK FOOTER //
// ./src/app/documents/components/DocumentsCard.jsx